// extracted by mini-css-extract-plugin
module.exports = {"body":"Block_body__3uLEn","categoryName":"Block_categoryName__1feFB","isActive":"Block_isActive__1dAHn","isDisabled":"Block_isDisabled__3ztnl"};